module.exports = __webpack_public_path__ + "static/media/proj2_img8.6829053a.jpg";